module.exports = __webpack_public_path__ + "img/bg-landing.dbc2164a.png";